'use client';

import { useTranslation } from 'react-i18next';

import ResponsiveLayout from '@/components/apps/layouts/responsive/Layout';
import Component from '@/components/apps/pages/solution/component/Component';
import VisuallyHiddenPageTitle from '@/components/apps/ui/a11y/VisuallyHiddenPageTitle';

export default function ComponentPageClient() {
  const { t } = useTranslation('common');
  const title = t('솔루션 구성요소');

  return (
    <>
      <VisuallyHiddenPageTitle>{title}</VisuallyHiddenPageTitle>
      <ResponsiveLayout mobilePadding={{ top: '0', bottom: '0' }}>
        <Component />
      </ResponsiveLayout>
    </>
  );
}
